"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselSlider: function() {
        return _index.CarouselSlider;
    },
    carouselSliderClassNames: function() {
        return _index.carouselSliderClassNames;
    },
    renderCarouselSlider_unstable: function() {
        return _index.renderCarouselSlider_unstable;
    },
    useCarouselSliderStyles_unstable: function() {
        return _index.useCarouselSliderStyles_unstable;
    },
    useCarouselSlider_unstable: function() {
        return _index.useCarouselSlider_unstable;
    }
});
const _index = require("./components/CarouselSlider/index");
